import { render, staticRenderFns } from "./OrganizationPendingOrders.vue?vue&type=template&id=5c598100"
import script from "./OrganizationPendingOrders.vue?vue&type=script&lang=js"
export * from "./OrganizationPendingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports